import React from 'react';
import { Localizer } from 'services/Localizer';

/**
 * An alert sent to users regarding products or promotions
 */
export interface OrderMessage {
	message: string;
	messageAction: OrderMessageAction;
}

/**
 * The level of action to be taken with an order message
 */
export enum OrderMessageAction {
	Info = 'Info',
	Warning = 'Warning',
	Error = 'Error',
	RedirectToCart = 'RedirectToCart',
}

interface OrderMessagesProps {
	orderMessages?: OrderMessage[];
	actions?: OrderMessageAction[];
}

/**
 * Custom component to notify the customer if cart has been updated which includes :
 * 1- Cart items pricing has been updated
 * 2- Cart Items availability has been updated
 * 3- Cart applied promotion expired
 */
function OrderMessages(props: OrderMessagesProps) {
	const { orderMessages, actions } = props;

	const messages =
		actions == null
			? orderMessages
			: orderMessages?.filter((orderMessage) => actions?.includes(orderMessage.messageAction));

	// Component is omitted if actions filtered out all the messages or there were none to begin with
	if (messages == null || messages.length === 0) {
		return null;
	}

	return (
		<div className="roc-container">
			<div className="roc-icon-text roc-toggle-form__error">
				<div data-testid="inline-alert-window" className="roc-alert roc-alert-warning roc-alert-full-width">
					<strong className="roc-alert-title roc-alert-title--space">{Localizer('OrderMessagesText')}</strong>
					<ul>
						{messages.map((orderMessage, index) => (
							<li data-testid="inline-alert-text" key={index}>
								<span dangerouslySetInnerHTML={{ __html: orderMessage.message }} />
							</li>
						))}
					</ul>
				</div>
			</div>
		</div>
	);
}

export default OrderMessages;
